export default __webpack_public_path__ + "images/BD.28adfba.png";